import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useOrchestrationStore = defineStore("orchestration", {
    actions: {
        async orchestrationListFetch(payload) {
            const body = {
                page: {
                    index: payload.index,
                    size: payload.size,
                    sort: "",
                },
                filter: {
                   shopUid: payload.shopUid,
                    cusUid:  payload.cusUid,
                    cusName:  payload.cusName,
                    txState:  payload.txState,
                    transferStatus:  payload.transferStatus,
                    refNumber:  payload.refNumber,
                    paymentGroupUid: payload.paymentGroupUid,
                    fromDate:  payload.fromDate,
                    toDate:  payload.toDate

                },
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/orch-svc/pawn/shop/tx/list";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },
        async orchestrationInfoFetch(payload) {
            return new Promise((resolve, reject) => {
            try {
                const pathUrl = "/orch-svc/pawn/shop/tx/" + payload.uid;
                const response = http.get(pathUrl);
                resolve(response);
            } catch (e) {
                reject(e);
            }
        });
    
        },
    }
});